import card1 from "../../assets/img/creditcard/card1.png";

const PersonalProductData = [
  {
    id: 1,
    heading: "Heading",
    color: "Blue",
    size: "Large",
    price: "$199",
    status: "Equifax",
    statusClass: "equifax",
    image: card1,
  },
  {
    id: 2,
    heading: "Heading",
    color: "Black",
    size: "Medium",
    price: "$499",
    status: "Transunion",
    statusClass: "transunion",
    image: card1,
  },
  {
    id: 3,
    heading: "Heading",
    color: "Blue",
    size: "Small",
    price: "$299",
    status: "In Stock",
    statusClass: "in-stock",
    image: card1,
  },
];

export default PersonalProductData;
